import { ModalFooter } from '@stitch-fix/mode-react';
type CancelReturnModalFooterProps = {
  handleModalClose: () => void;
  handleOnCancelReturn: () => void;
};

/**
 * Renders the cancel return in progress footer
 */
export const CancelReturnModalFooter = ({
  handleModalClose,
  handleOnCancelReturn
}: CancelReturnModalFooterProps) => {
  return <ModalFooter pt={0} primaryAction={{
    text: 'Yes',
    variant: 'filled-staple',
    onClick: () => {
      handleOnCancelReturn();
    }
  }} secondaryAction={{
    text: 'No',
    onClick: () => {
      handleModalClose();
    }
  }} />;
};